
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { Slideshow } from "eagle.js";
import VueFragment from "vue-fragment";
import DynamicSlideItem from "./DynamicSlideItem.vue";
import { from, delay, concatMap, of, map, switchMap } from 'rxjs'

function sortByKey(array, key) {
  return array.sort((a, b) => {
    let x = a[key];
    let y = b[key];

    return x < y ? -1 : x > y ? 1 : 0;
  });
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default {
  mixins: [Slideshow],
  components: {
    VueFragment,
    DynamicSlideItem,
  },
  data() {
    return {
      loading: true,
      autoPlay: false,
      autoPlaySchedule: null,
      autoPlaySubscriber: null,
      currentScheduleIndex: 0,
      autoPlayRunning: false,
    };
  },
  methods: {
    async autoCue() {
      for (let i = 0; i < this.cueWithRestItems.length; i++) {
        const currentCueItem = this.cueWithRestItems[i];
        if (currentCueItem.interval_type === "work") {
          this.nextSlide();
          await sleep(currentCueItem.interval * 1000);
        } else {
          await sleep(currentCueItem.interval * 1000);
        }
      }
    },
    recursivelyCallSchedule(){
      if (!this.activeCircuit){
        return
      }
      this.buildAutoCueSchedule()
      this.autoPlayRunning = true
      this.autoPlaySubscriber = this.autoPlaySchedule.subscribe(x => {
        this.autoPlayRunning = false
        if (this.activeCircuit.circuit_type === 'timer') {
          this.recursivelyCallSchedule()
        }
        else {
          this.nextSlide()
        }
      })
    },
    buildAutoCueSchedule(){
      console.log('cue with rests', this.activeCircuit.auto_cue_with_rests.filter(item => item.order >= this.currentSlideIndex-2))
      this.autoPlaySchedule = from(this.activeCircuit.auto_cue_with_rests.filter(item => item.order >= this.currentSlideIndex-2)).pipe(
        concatMap(currentCueItem => {
          if (currentCueItem.interval_type === "work") {
            return of(currentCueItem).pipe(
              switchMap((item)=>{
                this.nextSlide()
                return of(item)
              }),
              delay(currentCueItem.interval * 1000)
            )
          }
          else {
            return of(currentCueItem).pipe(delay(currentCueItem.interval * 1000))
          }
        })
      )
    }
  },
  async mounted() {
    this.loading = true;
    this.$store.commit("scripts/setActiveWorkout", this.$route.params.id);
    await this.$store.dispatch("scripts/getCircuits", this.$route.params.id);
    await this.$store.dispatch(
      `scripts/getAutoCueWithRests`,
      this.$route.params.id
    );
    await this.$store.dispatch(
      `${this.currentType}/getActivity`,
      this.$route.params.id
    );
    this.loading = false;
    this.findSlides()
    document.addEventListener('keyup', event => {
      if (event.code === 'Space') {
        if (this.activeCircuit.circuit_type === 'reps') {
          window.alert('Not possible to auto play with reps')
          return
        }
        this.autoPlay = !this.autoPlay
        if (this.autoPlay) {
          this.recursivelyCallSchedule()
        }
        else {
          this.autoPlaySubscriber.unsubscribe()
        }
      }

      let evt = event || window.event;
      var isEscape = false;
      if ("key" in evt) {
          isEscape = (evt.key === "Escape" || evt.key === "Esc");
      } else {
          isEscape = (evt.keyCode === 27);
      }
      if (isEscape) {
        this.autoPlay = false
        this.autoPlaySubscriber.unsubscribe()
      }
    })
  },
  watch: {
    slideItems(){
      console.log('slide items', this.slideItems)
      console.log('cue items', this.cueWithRestItemsWithCircuit)
      
    },
    currentSlideIndex(slideIndex) {
      console.log('Slide index', slideIndex)
      if (slideIndex > 2) {
        const item = this.slideItems[slideIndex-3]
        // look for current circuit where the move belong
        for (let i=0;i<this.cueWithRestItemsWithCircuit.length;i++) {
          const circuit = this.cueWithRestItemsWithCircuit[i]
          for (let j=0;j<circuit.auto_cue_with_rests.length;j++) {
            const auto_cue = circuit.auto_cue_with_rests[j]
            if (auto_cue.interval_type === 'rest') {
              continue
            }
            if (auto_cue.id === item.id) {
              console.log('Auto Cue', auto_cue)
              console.log('Item', item)
              this.currentScheduleIndex = i
              console.log('Current Schedule Index', this.currentScheduleIndex)
              console.log('Current Circuit', this.activeCircuit)
              // if (this.activeCircuit.circuit_type === 'timer') {
              //   this.buildAutoCueSchedule()
              //   this.autoPlay = true
              //   if (this.autoPlay) {
              //     this.recursivelyCallSchedule()
              //   }
              //   else {
              //     this.autoPlaySubscriber.unsubscribe()
              //   }
              // }

              break;
            }
          }
        }
        if (item.circuit_type === 'reps') {
          this.autoPlay = false
          if (this.autoPlaySubscriber) {
            this.autoPlaySubscriber.unsubscribe()
          }
        }
      }
      if (this.slideIndex === 1 && this.autoPlaySubscriber) {
        this.autoPlay = false
        this.autoPlaySubscriber.unsubscribe()
      }
    }
  },
  computed: {
    ...mapGetters({
      cueWithRestItems: "scripts/cueWithRestItems",
      circuits: "scripts/circuits",
      cueWithRestItemsWithCircuit: "scripts/cueWithRestItemsWithCircuit"
    }),
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    currentType() {
      const url = this.$route.path;
      if (url.includes("workout")) {
        return "workouts";
      }
      if (url.includes("warmup")) {
        return "warmups";
      }
      if (url.includes("stretch-flow")) {
        return "stretchflows";
      }
      return "commons";
    },
    slideItems() {
      const result = sortByKey(
        this.cueWithRestItems.filter((item) => item.interval_type === "work"),
        "order"
      );
      return result.length > 0 ? result : [];
    },
    slideItemCount() {
      return this.slideItems.length === 0 && this.loading
        ? 1
        : this.slideItems.length;
    },
    backgroundClass() {
      if (this.step === 1) {
        return "title-slide";
      } else {
        return "content-slide";
      }
    },
    activeCircuit(){
      return this.cueWithRestItemsWithCircuit[this.currentScheduleIndex]
    }
  },
};
</script>

<style scoped>
.title-slide{
  background-color: #469a2e;
}

.title-slide .top {
  height: 20vh;
}

.title-slide .content {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-slide .bottom {
  height: 20vh;
}

.title-slide .circuit-types {
  list-style-type: none;
}
</style>

<template>
  <div>
    <div class="eg-slideshow">
      <slide v-if="loading"/>
      <slide v-if="!loading">
        <div class="title-slide">
          <div class="top">
            <ul class="circuit-types" v-if="currentActivity.timer_on_screen!='no'">
              <li v-for="circuit in circuits" :key="circuit.id">
                <span v-if="circuit.type === 'timer'"
                  >{{ circuit.work }} / {{ circuit.rest }}</span
                >
                <span v-else>REPS</span>
              </li>
            </ul>
          </div>
          <div class="content">
            <h1>{{ currentActivity.working_title }}</h1>
          </div>

          <div class="bottom">
            <h3>{{ currentActivity.notes }}</h3>
          </div>
        </div>
      </slide>
      <slide>
        <div class="main-wrap get-ready">
          <div class="content">
            <h1>GET READY</h1>
          </div>
        </div>
      </slide>
      <slide
        v-for="(item, index) in slideItems"
        :key="item.id + index + item.order"
      >
        <dynamic-slide-item :item="item"></dynamic-slide-item>
      </slide>
    </div>
  </div>
</template>
